<template>
    <div>
        <!-- <v-card class="mb-4 mt-0" elevation="0"> -->
            <!-- <v-card-text> -->
                <v-row>
                    <v-col class="py-2">
                        <div class="border-customer-file-input">
                            <fileInputForm
                                :accept="'.pdf,.PDF'"
                                label="Obtener datos de constancia de situación fiscal (CIF)"
                                :multiple="false"
                                :valueInput="values.aux_file"
                                :rule="[]"
                                appendIcon="mdi-tray-arrow-up"
                                :loading="loadingFile"
                                @valueChange="(v) => {values.aux_file = v; delete serverErrors.aux_file; readFile(v)}"
                                :errorMessages="serverErrors.aux_file"
                                v-on:update:url="values.aux_file = $event"
                            ></fileInputForm>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.name = v; delete serverErrors.name}" 
                            :valueInput="values.name" 
                            :rule="[...rules.required, ...rules.max]" 
                            label="Nombre o Razón Social"
                            :errorMessages="serverErrors.name"
                            :disabled="lockName"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.email = v; delete serverErrors.email}" 
                            :valueInput="values.email" 
                            :rule="[...rules.required, ...rules.email]" 
                            label="Correo"
                            :errorMessages="serverErrors.email"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.rfc = v; delete serverErrors.rfc; delete serverErrors[`clientModel.Rfc`]}" 
                            :valueInput="values.rfc" 
                            :rule="rules.rfc" 
                            label="RFC"
                            :errorMessages="serverErrors.rfc"
                            :disabled="lockRfc"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.contact = v; delete serverErrors.contact}" 
                            :valueInput="values.contact" 
                            :rule="rules.required" 
                            label="Contacto"
                            :errorMessages="serverErrors.contact"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <autocompleteOneForm
                            label="Origen"
                            
                            :valueInput="values.origin"
                            :rule="rules.required"
                            :items="items.origins"
                            :errorMessages="serverErrors.origin"
                            @valueChange="(v) => {values.origin = v; this.originCountry();delete serverErrors.origin}"
                        ></autocompleteOneForm>
                    </v-col>
                    <v-col class="py-2" cols="12" md="6">
                        <autocompleteOneForm
                            label="País"
                            
                            :valueInput="values.country_code"
                            :rule="rules.required"
                            :items="items.countries"
                            :errorMessages="serverErrors.country_code"
                            :returnObject="true"
                            @valueChange="(v) => {values.country_code = v; delete serverErrors.country_code}"
                            :disabled="values.origin == 'NACIONAL' ? true : false"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>

              

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.address = v; delete serverErrors.address}" 
                            :valueInput="values.address" 
                            :rule="rules.required"
                            label="Calle"
                            :errorMessages="serverErrors.address"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.exterior_number = v; delete serverErrors.exterior_number}" 
                            :valueInput="values.exterior_number" 
                            :rule="rules.required"
                            label="Número"
                            :errorMessages="serverErrors.exterior_number"
                        ></textFieldForm>
                    </v-col>
                     <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.interior_number = v; delete serverErrors.interior_number}" 
                            :valueInput="values.interior_number" 
                           
                            label="Número Interior"
                            :errorMessages="serverErrors.interior_number"
                        ></textFieldForm>
                    </v-col>
                </v-row>


                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.neighborhood = v; delete serverErrors.neighborhood}" 
                            :valueInput="values.neighborhood" 
                            :rule="rules.required"
                            label="Colonia"
                            :errorMessages="serverErrors.neighborhood"
                        ></textFieldForm>
                    </v-col>

                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.zip_code = v; delete serverErrors.zip_code}" 
                            :valueInput="values.zip_code" 
                            :rule="rules.required"
                            label="Código postal"
                            :errorMessages="serverErrors.zip_code"
                        ></textFieldForm>
                    </v-col>
                </v-row>



                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.state = v; delete serverErrors.state}" 
                            :valueInput="values.state" 
                            :rule="rules.required"
                            label="Estado"
                            :errorMessages="serverErrors.state"
                        ></textFieldForm>
                    </v-col>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.city = v; delete serverErrors.city}" 
                            :valueInput="values.city" 
                            :rule="rules.required"
                            label="Municipio"
                            :errorMessages="serverErrors.city"
                        ></textFieldForm>
                    </v-col>
                </v-row>


                <v-row>
                    <v-col class="py-2">
                       <autocompleteOneForm
                            label="Régimen Fiscal"
                            :loading="loadingFiscal"
                            :valueInput="values.fiscal_regime"
                            :rule="rules.required"
                            :items="items.fiscalRegimens"
                            :errorMessages="serverErrors.fiscal_regime"
                            @valueChange="(v) => {values.fiscal_regime = v; delete serverErrors.fiscal_regime}"
                            :disabled="lockFr"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <autocompleteOneForm
                            label="Uso de CFDI"
                            :loading="loadingCfdi"
                            :valueInput="values.cfdi_use"
                            :rule="rules.required"
                            :items="items.cfdiUses"
                            :errorMessages="serverErrors.cfdi_use"
                            @valueChange="(v) => {values.cfdi_use = v; delete serverErrors.cfdi_use}"
                           
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>


                <v-row v-if="edit">
                    <v-col class="py-2">
                        <switchForm
                            title="Estatus"
                            leftLabel=""
                            :rightLabel="values.status ? 'Activo': 'Inactivo'"
                            :valueInput="values.status"
                            
                            @valueChange="(v) => {values.status = v; delete serverErrors.status}"
                        ></switchForm>
                    </v-col>
                </v-row>



                
                
                
            <!-- </v-card-text> -->
        <!-- </v-card> -->

    </div>
</template>

<script>
import json from "@/assets/json/countries.json";
/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit'],
   
    data(){
        return {
            disableSelect: false,
            loadingCfdi: false,
            loadingFiscal: false,
            loadingFile:false,
            lockName:false,
            lockRfc:false,
            lockFr:false,
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
                rfc: [
                    (v) => !!v || "El campo requerido",
                    (v) => v.length <= 13 || "Debe de ser entre 12 y 13 caracteres",
                    (v) => v.length >= 12 || "Debe de ser entre 12 y 13 caracteres",
                    
                ],
                max: [
                    (v) => v.length <= 100 || "Máximo 100 caracteres"
                ],

                email: [
                    (v) => {
                        const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(v) || "Correo no válido";
                    },
                ],
				
				
            },

            items: {
                origins: [
                    { text: "NACIONAL", value: "NACIONAL" },
                    { text: "INTERNACIONAL", value: "INTERNACIONAL" },
                ],
                countries: [],
                cfdiUses: [],
                fiscalRegimens: [],
            }
            

          
        }
    },

    watch: {
      
        [`values`]: function (value) {
            console.log(value)            
        }
    },
   
    mounted(){
        this.getCountries();
        this.getCfdiUses();
        this.getFiscalRegimens();
    },
    methods: {
        getCountries()
        {
            json.forEach(c => {
                this.items.countries.push({text: c.name, value: c.code});
            });
        },
        originCountry() {
            if (this.values.origin === "NACIONAL") {
                this.values.country_code = {text: "MÉXICO", value:"MX"};
                
            } else {
                
                this.values.country_code = null;
            }
        },

        getCfdiUses()
        {
            this.loadingCfdi = true;
            this.$api.taxInvoice.cfdiUses()
				.then((resp) =>{
					this.items.cfdiUses = resp.data.map((x) => {
                        return {text: `${x.Value} - ${x.Name}`, value: x.Value}
                    });
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingCfdi = false;
				})
			;
        },

        getFiscalRegimens()
        {
            this.loadingFiscal = true;
            this.$api.taxInvoice.fiscalRegimens()
				.then((resp) =>{
					this.items.fiscalRegimens = resp.data.map((x) => {
                        return {text: `${x.Value} - ${x.Name}`, value: x.Value}
                    });
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingFiscal = false;
				})
			;
        },


        readFile(file){
            if(file == null || file.length == 0){
                this.clearFields();
                return;
            }
            let formdata = new FormData();
            formdata.append("certificate", file);
            this.loadingFile = true;
            this.$api.taxInvoice.readCertificate(this.$store.state.business, formdata)
				.then((resp) =>{
                    this.clearFields();
                    this.values.name = resp?.data?.razon_social??'';
                    this.lockName = this.values.name != '';
                    this.values.rfc = resp.data?.rfc??'';
                    this.lockRfc = this.values.rfc != '';
                    const fr = this.items.fiscalRegimens.find((x) => x.text.toLowerCase().includes(resp.data.regimenes[resp.data.regimenes.length - 1].regimen.toLowerCase()) == true)
                    if(fr != undefined){
                        this.values.fiscal_regime =fr.value;
                        this.lockFr = true;
                    }
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingFile = false;
				})
			;
        },

        clearFields(){
            this.values.name = "";
            this.values.rfc = "";
            this.values.fiscal_regime = "";
            this.lockFr = this.lockName = this.lockRfc = false;
        },
       
    }
}
</script>

<style lang="scss">
    .border-customer-file-input{
        border:  var(--v-primary-base) solid 2px;
        border-radius: 5px;
    }
</style>